/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading, startLoadding} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  tags: [],
}

export const GetAllData: any = createAsyncThunk('base-tag-data', async (data: any, thunkApi) => {
  const response = await axios.get(`${API_URL}tags`, {
    params: {...data, isExcludeList: 'true'},
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })

  let ids = response?.data?.data?.items?.map((val: any) => val?._id)
  thunkApi.dispatch(
    TagsCount({
      tagId: ids,
    })
  )
  thunkApi.dispatch(stopLoading())
  return response.data
})
export const TagsCount: any = createAsyncThunk('TagsCount', async (data, thunkApi) => {
  const response = await axios.post(`${API_URL}tags/tagsCount`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())
  return response.data
})

export const DeleteData: any = createAsyncThunk('base-tag-delete', async (data, thunkApi) => {
  const response = await axios.put(`${API_URL}tags/deleteTags`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status === true && toast.success(response.data.message)
  }

  thunkApi.dispatch(GetAllData())
})

export const DeleteContactFromList: any = createAsyncThunk('base-tag-delete', async (data, thunkApi) => {
  const response = await axios.put(`${API_URL}tags/delete-contacts`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status === true && toast.success(response.data.message)
  }

  thunkApi.dispatch(GetAllData())
})


export const UpdateData: any = createAsyncThunk('base-tag-edit', async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())
  const response = await axios.post(`${API_URL}tags/${data?.id}`, data.data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data?.status === true && toast.success(response.data.message)
  }
  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetAllData())
})

export const CreateData: any = createAsyncThunk(
  'base-tag-create',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}tags`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status === true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData())
  }
)

const BaseTag = createSlice({
  name: 'BaseTag',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, tags: action?.payload}
    })
    builder.addCase(TagsCount.fulfilled, (state, action) => {
      return {...state, tagsContactCount: action?.payload}
    })
  },
})

export const getFilterContactTag = (state: any) => state?.tags?.filterTagsContact?.data
export const getTagContactCount = (state: any) => state?.tags?.tagsContactCount?.data

export default BaseTag.reducer
